/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsRevenueAveragePlaceholderCtrl
 */
angular.module('mercury.modules.reports.revenue')
.controller('ReportsRevenueAveragePlaceholderCtrl', function() {
  console.log('in reports revenue average placeholder controller');
});
